<script setup>
import { ref, computed, onMounted } from 'vue'
import RecentActivity from './RecentActivity.vue'
import DashboardBoxesOverall from './DashboardBoxesOverall.vue'
import DashboardStandings from './DashboardStandings.vue'
import { dashboardAPI } from '../../services/api.js'
import Loading from '@/components/Loading.vue'
import DashboardBoxesBestWins from './DashboardBoxesBestWins.vue'

// Reactive data
const loading = ref(true)
const error = ref(null)
const topPlayers = ref([])
const monthlyTopPlayers = ref([])
const totalStats = ref({
  totalBets: 0,
  totalWinnings: 0,
  totalLost: 0,
  activePlayers: 0
})
const bestWins = ref()
const recentActivity = ref([])

// Methods
const loadDashboardStats = async () => {
  try {
    loading.value = true
    error.value = null
    
    const response = await dashboardAPI.getStats()
    
    if (response.success) {
      const data = response.data
      
      // Aggiorna le statistiche totali
      totalStats.value = {
        totalBets: data.total_stats.total_bets,
        totalWinnings: data.total_stats.total_winnings,
        totalLost: data.total_stats.total_lost,
        activePlayers: data.total_stats.active_players
      }
      bestWins.value = data.best_wins
      
      // Aggiorna i top players
      topPlayers.value = data.top_players
      monthlyTopPlayers.value = data.monthly_top_players
      recentActivity.value = data.recent_activity
      
    } else {
      error.value = 'Errore nel caricamento delle statistiche'
    }
  } catch (err) {
    console.error('Errore nel caricamento della dashboard:', err)
    error.value = 'Impossibile caricare le statistiche della dashboard'
  } finally {
    loading.value = false
  }
}

// Lifecycle
onMounted(() => {
  loadDashboardStats()
})
</script>

<template>
  <v-container fluid class="px-0 px-sm-4">
    <!-- Loading State -->
    <Loading v-if="loading" />

    <!-- Error State -->
    <v-alert v-else-if="error" type="error" class="mb-6">
      <div class="d-flex align-center justify-space-between">
        <span>{{ error }}</span>
        <v-btn 
          size="small" 
          variant="text" 
          @click="loadDashboardStats"
          :loading="loading"
        >
          Riprova
        </v-btn>
      </div>
    </v-alert>

    <!-- Dashboard Content -->
    <v-fade-transition>
      <div v-if="!loading">
        <!-- Statistiche Rapide -->
        <DashboardBoxesBestWins :best-wins="bestWins" />

        <!-- Top Players Standings -->
        <DashboardStandings 
          :top-players="topPlayers" 
          :monthly-top-players="monthlyTopPlayers" 
        />

        <DashboardBoxesOverall :total-stats="totalStats" />

        <!-- Attività Recente -->
        <v-row class="mt-6">
          <v-col cols="12">
            <RecentActivity 
              :recent-activity="recentActivity" 
              :loading="loading"
            />
          </v-col>
        </v-row>
      </div>
    </v-fade-transition>
  </v-container>
</template>

<style scoped>
.v-card {
  transition: transform 0.2s ease-in-out;
}

.v-card:hover {
  transform: translateY(-2px);
}
</style>